var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBackgroundImage = function SvgBackgroundImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1441,
    height: 230,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F6F9",
    d: "M1440.53 2.471c-55.49-3.432-60.04-.32-196.01.008H733.022l-573.001-.001c-135.965.329-132-.004-160.01.006v4C.282 114.16 238.596 229.357 374.562 229.028l346.11-.837 352.727-.853c135.96-.328 367.4-117.191 367.13-224.868"
  })));
};
export { SvgBackgroundImage as ReactComponent };
export default "/_next/static/media/src/global/pageComponents/ManufacturerLineCard/_assets/backgroundImage.96de6747e3b795978d6f12a7175c9d89.svg";